import dayjs from 'dayjs';
import React, { Component } from 'react';
import { divisionNumber, formatCity } from '../../../untils/auth';

export default class EmptyLegList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showElem: true, // 按钮是否隐藏
      currentPage: 0, // 点击次数
      pageSize: 10,
    };
  }
  submitHandle = (item) => {
    this.props.history.push({
      pathname: `/emptyLegDetails/${item.Id}`,
      state: item,
    });
  };

  //点击加载更多
  getMoreData = () => {
    let { currentPage, pageSize } = this.state;
    let list = this.props.emptyLegList;
    let showElem = true;
    currentPage++;
    if (currentPage >= Math.ceil(list.length / pageSize)) {
      showElem = false;
    }
    this.setState({
      currentPage,
      showElem,
    });
  };

  render() {
    let { emptyLegList } = this.props;
    let { currentPage, pageSize } = this.state;

    const start = currentPage * pageSize;

    return (
      <div>
        <ul className="empty_leg_list">
          {emptyLegList?.slice(0, start + pageSize).map((item) => {
            return (
              <li
                key={item.Id}
                onClick={() => {
                  this.submitHandle(item);
                }}
              >
                <div className="img">
                  {item.Aircraft.Picture &&
                    item.Aircraft.Picture.map((items, index) => {
                      return index < 1 ? (
                        <img
                          key={index}
                          src={`${process.env.REACT_APP_RESOURCE_URL}/${items}`}
                          alt={`private jet charter empty legs ${item.Aircraft.Model}`}
                        />
                      ) : null;
                    })}
                </div>
                <div className="text_content">
                  <p className="date">
                    {dayjs(new Date(item.startDate)).format('MMM DD')} -{' '}
                    {dayjs(new Date(item.endDate)).format('MMM DD')}
                  </p>
                  <div className="flight_info">
                    <div className="city_name">
                      <span>
                        {formatCity(item.startAirport?.City)}, {item.startAirport.StateCode},{' '}
                        {item.startAirport.CountryIso2}
                      </span>
                      <img
                        src={require('../../../assets/imgs/svg/emptyLeg/plane-icon.svg').default}
                        alt="trip icon"
                      />
                      <span>
                        {formatCity(item.endAirport?.City)}, {item.endAirport.StateCode},{' '}
                        {item.endAirport.CountryIso2}
                      </span>
                    </div>
                    <div className="airport_code">
                      <span>({item.startAirport.Icao})</span>
                      <span>({item.endAirport.Icao})</span>
                    </div>
                  </div>
                  <div className="price_bottom">
                    <div className="seat">
                      <img
                        src={require('../../../assets/imgs/svg/black-seat.svg').default}
                        alt="seat icon"
                      />
                      <span>{item.Aircraft.Seats}</span>
                    </div>
                    <div className="list_total">
                      <div className="reply_total_price">
                        <span>Charter</span>
                        <span>${divisionNumber(item.price)}</span>
                      </div>

                      <button className="inquire_btn">Inquire</button>
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
        <div>
          {this.state.showElem ? (
            <button className="getmore_btn" onClick={this.getMoreData}>
              view more
            </button>
          ) : (
            <p className="nomore">No more content...</p>
          )}
        </div>
      </div>
    );
  }
}
